import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { goToDashboard } from '../routes/coordinator'

const useUnprotectedPage = () => {
  const history = useNavigate()
  useEffect(() => {
    const token = localStorage.getItem('token')
    if (token) {
      goToDashboard(history)
    }
  }, [history])
}

export default useUnprotectedPage
